import React, { useEffect, useState } from 'react';
import axiosInstance from './axiosInstance';

const Profile = () => {
  const [userInfo, setUserInfo] = useState({});

  const fetchUserInfo = async () => {
    try {
      const response = await axiosInstance.get('/api/user/info');
      setUserInfo(response.data); // Save user data in state
    } catch (error) {
      console.error('Error fetching user info:', error);
    }
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  return (
    <div>
      <h1>Profile</h1>
      <p>Username: {userInfo.username}</p>
      <p>Email: {userInfo.email}</p>
      <p>Stars: {userInfo.stars}</p>
      <p>Rating Count: {userInfo.ratingCount}</p>
      <p>Average Rating: {userInfo.averageRating}</p>
    </div>
  );
};

export default Profile;